import BackButton from '@/components/back-button/back-button';
import { Box, Flex, Image } from '@cmpsr/components';

type IntroWizardsNavBarProps = {
  onBackButtonClick: () => void;
  hideBackButton?: boolean;
  showLogo?: boolean;
};

export default function IntroWizardsNavBar(props: IntroWizardsNavBarProps) {
  return (
    <Flex
      as="nav"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      w="full"
      maxW="1440px"
      h={{ base: '70px', lg: '80px' }}
      mx="auto"
      px={{ base: 5, md: 8, lg: 16, xl: 24, xxl: 32 }}
      zIndex="1"
    >
      {props.hideBackButton ? <Box /> : <BackButton onClick={props.onBackButtonClick} />}
      {props.showLogo ? <Image src="/images/logo-catch-icon-white.svg" w="30px" h="30px" alt="" /> : null}
    </Flex>
  );
}
